export const environment = {
  production: false,
  localDomain: '', // local domain for development example: https://xyz.deskusend.com
  baseUrl: "https://backend.desku.io/api/tenant/",
  baseHostName: "console.desku.io",
  domainType: "dev", // in or io or dev — io → backend.deskudocs.com for initial get-domain
  isLocal: 0, // 1 = local,0=live Language file load server or local assets folder,
  version: "DeskuDocs@2.93",
  dev_bunnycdn_url: 'https://backend.deskusend.com/',
  io_bunnycdn_url: 'https://desku-docs.b-cdn.net/',
  seo: {
    getDomainApiUrl: 'https://backend.deskusend.com/api/',
    canonicalOrigin: 'https://desku.io',
    canonicalKbSlug: 'docs',
    legacyKbHostnames: [] as string[]
  },
  devConsoleSegmentApiKey: 'U2FsdGVkX1/4kH1BLfSq9fag2toqhIyCY4btMYog1rD9KpiipyA/Qce7rQAR7p3EjLgzfZHy/qHUxcCI1fJKnw==',
  ioConsoleSegmentApiKey: 'U2FsdGVkX18KCFww0I3kk5FHrkZgmuk9Etd4UMC5DbZ5jOxFnpxTNL5o3vAz394ghIb+z1XdnyqsjCS4rz2JZA==',
  appSessionSeed: '0WlR',
};
